<template>
  <div class="twere111">
    <div class="llerwer111">
      <div class="jjkfdd22">
        <div class="leftlogo">
          <img style="width: 1.8rem;height: 1.8rem;" src="@/assets/xxkc/dibu2.png"/>
          <p class="nilfsdf"> INTERNATIONAL DATA GOVERNANCE ASSOCIATION</p>
        </div>
        <div class="rightjdfd">
          <img class="kskdfdb" src="@/assets/xxkc/icon_mail.png"/>
          <p class="nkererh" @click="gotoLianxi">联系我们</p>
          <img class="kskdfdb1" src="@/assets/xxkc/huiyuan.png"/>
          <p class="nkererh" @click="gotoJiaru">申请入会</p>
        </div>
      </div>
    </div>
    <div class="llerwer">
      <div class="jjkfdd22">
        <div class="leftlogo111">
          <p class="llerewt">国际数据治理协会</p>
          <p class="llerewt" style="color: #8a8a8a">/</p>
          <p class="llerewt" style="color: #8a8a8a">驭数空间</p>

        </div>
        <div class="rightjdfd1">
<!--          <p class="">Contract Us</p>-->
<!--          <p class="">Contract Us</p>-->
<!--          <p class="">Contract Us</p>-->
<!--          <p class="">Contract Us</p>-->
<!--          <p class="">Contract Us</p>-->
<!--          <p class="">Search</p>-->
          <nav class="nav-menu">
            <template v-for="(item, index) in navItems">
              <router-link :to="item.menuurl" class="nav-item" active-class="active">
                <template>{{ item.menuname }}</template>
              </router-link>
            </template>
          </nav>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KcHeader',
  components: {},
  data() {
    return {
      navItems: [

      ],
      currentPageNo:0,
      curentPageSize:100,
      pages:0,
      total:0,
      fields: 'id,menuname,menuurl,action',
    }
  },
  mounted() {
    this.refresh();
  },
  computed: {
    isActive(routePath) {
      return this.$route.path === routePath;
    }
  },
  methods:{
    gotoJiaru(){
      this.$router.push({path:'/yonghuzhuce'});
    },
    gotoLianxi(){
      this.$router.push({path:'/lianxiwomen'});
    },
    refresh (pageNo) {
      this.currentPageNo = pageNo;
      if(!this.currentPageNo){
        this.currentPageNo = 0;
      }
      var that = this;
      this.$ajax
          .get(this.GLOBAL.sys_addr + '/tmenu/tMenu/list?_t='+new Date().getTime()+'&column=menuorder&order=asc&field='+this.fields+'&pageNo='+this.currentPageNo+'&pageSize='+this.curentPageSize)
          .then(function (response) {
            if (response.data.code == 200) {
              debugger
              that.navItems = response.data.result.records;
              that.pages = response.data.result.pages;
              that.total = response.data.result.total;
            } else {
              that.$notify.warning({ position: 'bottom-right', title: '提示', message: response.data.msg });
            }
          });

    },
  }
}
</script>

<style  scoped>
.oower {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.twere111 {
  width: 100%;
  background-color: #fff;
  display: flex;
  margin: 0 auto;
  z-index: 99999;;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.llerwer111{
  width: 100%;
  min-height: 2.8rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.llerwer{
  width: 100%;
  min-height: 3.6rem;
  background-color: #f4f4f4;
  display: flex;
  justify-content: center;
  align-items: center;
}
.jjkfdd {
  width: 80%;
  display: flex;
  justify-content: space-between;
}
.jjkfdd22 {
  width: 80%;
  display: flex;
  justify-content: space-between;
}
.leftlogo {
  display: flex;
  justify-content: start;
  align-items: center;
  font-size: 1.4rem;
  font-weight: bold;
}
.nilfsdf{
  font-size: 13px;
  margin-left: 10px;
}
.leftlogo111 {
  display: flex;
  justify-content: start;
  align-items: center;
  font-size: 1rem;
  font-weight: bold;
  padding-left: 0.2rem;
  gap:1rem;
}
.llerewt{
  font-size: 13px;
}
.rightjdfd {
  display: flex;
  justify-content: end;
  align-items: center;
  font-size: 1rem;
  gap: 0.5rem;
}
.rightjdfd1 {
  width: 70%;
  display: flex;
  justify-content: end;
  align-items: center;
  font-size: 1rem;
  gap: 1rem;
}
.kskdfdb{
  width: 1rem;
  height: 1rem;
}
.kskdfdb1{
  margin-left: 1rem;
  width: 0.9rem;
  height: 0.9rem;
}
.nav-item{
  font-size: 14px;
  color: #222222;
}
.nkererh{
  font-size: 12px;
}
.nkererh:hover{
  cursor: pointer;
  color: #8a8a8a;
}
.nav-item:hover{
  color:#0f91e7;
}
.nav-menu{
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  gap: 25px;
}
.active {
  color: #409EFF; /* 高亮颜色 */
  font-weight: bold;
}
</style>
